var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLaptop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 13.3V5.7A2.7 2.7 0 0 1 3.7 3h12.6A2.7 2.7 0 0 1 19 5.7v7.6a2.7 2.7 0 0 1-2.7 2.7H19a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h2.7A2.7 2.7 0 0 1 1 13.3M16.3 5H3.7a.7.7 0 0 0-.7.7v7.6a.7.7 0 0 0 .7.7h12.6a.7.7 0 0 0 .7-.7V5.7a.7.7 0 0 0-.7-.7"
})));
export default SvgIconLaptop;